import { useState } from "react";
import { Download, X, Share, Smartphone, Monitor } from "lucide-react";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

const DISMISS_KEY = "pwa_install_dismissed_v1";

export default function InstallAppBanner() {
  const { canInstall, installed, isIOS, isMobileOrTablet, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  const [showIOS, setShowIOS] = useState(false);

  // Déjà installée, fermée, ou rien à proposer → on n'affiche rien.
  if (installed || dismissed) return null;
  if (!canInstall && !isIOS) return null;

  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
  };

  const phrase = isMobileOrTablet
    ? "Installez l'application PROXIreduc-28 sur votre écran d'accueil"
    : "Ajoutez PROXIreduc-28 à votre bureau pour un accès en un clic";

  const onInstall = async () => {
    if (canInstall) { await promptInstall(); return; }
    if (isIOS) setShowIOS((v) => !v);
  };

  return (
    <div className="bg-[#E05638] text-white" data-testid="install-app-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-3">
        {isMobileOrTablet
          ? <Smartphone size={18} className="shrink-0" />
          : <Monitor size={18} className="shrink-0" />}
        <span className="text-sm font-medium flex-1 min-w-0">{phrase}</span>
        <button
          onClick={onInstall}
          data-testid="install-app-button"
          className="shrink-0 inline-flex items-center gap-1.5 bg-white text-[#E05638] font-semibold text-sm rounded-full px-3 py-1.5 hover:bg-orange-50 transition-colors"
        >
          <Download size={15} /> Installer
        </button>
        <button
          onClick={close}
          aria-label="Fermer"
          data-testid="install-app-close"
          className="shrink-0 p-1 rounded-md hover:bg-white/15"
        >
          <X size={16} />
        </button>
      </div>
      {showIOS && (
        <div className="bg-white text-slate-800 border-t border-orange-200" data-testid="install-ios-instructions">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 text-sm flex items-start gap-2">
            <Share size={16} className="text-[#E05638] mt-0.5 shrink-0" />
            <span>
              Sur iPhone / iPad : appuyez sur <b>Partager</b> <Share size={13} className="inline align-text-bottom" />,
              puis choisissez <b>« Sur l'écran d'accueil »</b>.
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
